export default __webpack_public_path__ + "static/get-it-all-bg-left-7dda1041a7769b31e660474281ee12dd.png";